export default __webpack_public_path__ + "static/media/ad.2a591b19.svg";